import { render, staticRenderFns } from "./SingleCardLayout.vue?vue&type=template&id=70f0ec19&scoped=true&"
import script from "./SingleCardLayout.vue?vue&type=script&lang=js&"
export * from "./SingleCardLayout.vue?vue&type=script&lang=js&"
import style0 from "./SingleCardLayout.vue?vue&type=style&index=0&id=70f0ec19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f0ec19",
  null
  
)

export default component.exports